import AnimatedSection from '../common/AnimatedSection'
import { servicesIndustries, servicesIndustriesSection } from '../../data/servicesPageData'

function ServicesIndustries() {
  const { eyebrow, titleLine1, titleAccent, description } = servicesIndustriesSection

  return (
    <AnimatedSection className="services-industries-section">
      <div className="container corp-container">
        <header className="services-section-header services-section-header--center">
          <span className="section-label section-label--gold">{eyebrow}</span>
          <h2>
            {titleLine1} <span>{titleAccent}</span>
          </h2>
          <p>{description}</p>
        </header>

        <div className="services-industries-grid" role="list">
          {servicesIndustries.map((industry) => {
            const Icon = industry.icon
            return (
              <article className="services-industry-card" key={industry.name} role="listitem">
                <span className="services-industry-card__icon" aria-hidden="true">
                  <Icon />
                </span>
                <h3>{industry.name}</h3>
              </article>
            )
          })}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default ServicesIndustries
